import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import './index.css';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';

import * as Sentry from '@sentry/react';

const appEnv = import.meta.env.VITE_APP_ENV ?? 'development';
const isProd = appEnv === 'production';
const isStaging = appEnv === 'staging';

Sentry.init({
  dsn: 'https://2597a6fce6717e6a0334b14695c46a61@o4511133598613504.ingest.us.sentry.io/4511133600186368',
  enabled: isProd || isStaging,
  environment: appEnv,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: true,
      blockAllMedia: true,
    }),
  ],
  // Free tier: 10K traces/month — prod 5%, staging 2%, dev off
  tracesSampleRate: isProd ? 0.05 : isStaging ? 0.02 : 0,
  // Free tier: 50 replays/month — session off, only capture on error in prod/staging
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: isProd ? 0.5 : isStaging ? 0.3 : 0,
  sendDefaultPii: false,
  ignoreErrors: [
    'ResizeObserver loop limit exceeded',
    'ResizeObserver loop completed with undelivered notifications',
    /ChunkLoadError/,
    'Non-Error promise rejection captured',
  ],
  denyUrls: [
    /extensions\//i,
    /^chrome:\/\//i,
    /^chrome-extension:\/\//i,
    /^moz-extension:\/\//i,
  ],
});

// Disable browser scroll restoration so the SPA can manage scroll positions explicitly
window.history.scrollRestoration = 'manual';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>
);
